var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsDateString, IsObject, IsOptional, IsUUID } from 'class-validator';
import { UserProfileDto } from '../../user/dto/user.profile.dto.js';
/**
 * Lightweight appointment header carried by the appointment participation
 * notifications (`APPOINTMENT_INVITE` / `_ACCEPTED` / `_DECLINED` /
 * `_ACCEPT_SUCCESS` / `_DECLINE_SUCCESS`). Sourced from the `Appointment`
 * aggregate at enrichment time — independent of the video-call (`Call`)
 * extension, so in-person appointments carry it too. Only the fields the
 * notification composer needs (therapist, scheduled start, cancellation) are
 * exposed.
 */
export class NotificationAppointmentDto {
    id;
    therapistId;
    scheduledStart;
    isCanceled;
    therapist;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], NotificationAppointmentDto.prototype, "id", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    Expose(),
    __metadata("design:type", Object)
], NotificationAppointmentDto.prototype, "therapistId", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], NotificationAppointmentDto.prototype, "scheduledStart", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], NotificationAppointmentDto.prototype, "isCanceled", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    Type(() => UserProfileDto),
    Expose(),
    __metadata("design:type", Object)
], NotificationAppointmentDto.prototype, "therapist", void 0);
//# sourceMappingURL=notification-appointment.dto.js.map